import { useCallback, useEffect, useState } from "react";
import { CheckCircle2, XCircle, AlertTriangle, RefreshCw, ClipboardCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import api from "@/lib/api";
import { WebhookSelfTest } from "@/components/whatsapp/WebhookSelfTest";
import { TestBatchesCleanup } from "@/components/whatsapp/TestBatchesCleanup";

const ICON = {
  ok: [CheckCircle2, "text-emerald-400"],
  warn: [AlertTriangle, "text-amber-400"],
  error: [XCircle, "text-red-400"],
};

export function SetupChecklist({ contestId, refreshKey }) {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.whatsappChecklist(contestId).then(setData).catch(() => {}), [contestId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  if (!data) return null;
  return (
    <Card className="p-5 bg-card border-border space-y-3" data-testid="whatsapp-checklist">
      <div className="flex items-center justify-between">
        <h3 className="font-display font-bold text-lg flex items-center gap-2"><ClipboardCheck className="h-4 w-4" /> Checklist configurazione</h3>
        <div className="flex items-center gap-2">
          <span className={`text-xs font-semibold rounded-full px-2.5 py-1 border ${data.ok ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" : "bg-amber-500/15 text-amber-400 border-amber-500/30"}`} data-testid="whatsapp-checklist-status">
            {data.ok ? "Tutto pronto" : `${data.items.filter((i) => !i.ok).length} da sistemare`}
          </span>
          <Button size="sm" variant="ghost" className="h-7 w-7 p-0" onClick={load} data-testid="whatsapp-checklist-refresh"><RefreshCw className="h-3.5 w-3.5" /></Button>
        </div>
      </div>
      <ul className="space-y-1.5">
        {data.items.map((i) => {
          const [Icon, cls] = ICON[i.level] || ICON.error;
          return (
            <li key={i.key} className="flex gap-2 text-sm" data-testid={`whatsapp-check-${i.key}`}>
              <Icon className={`h-4 w-4 mt-0.5 shrink-0 ${cls}`} />
              <div className="min-w-0">
                <div className="font-medium">{i.label}</div>
                {i.detail && <div className="text-[11px] text-muted-foreground break-all">{i.detail}</div>}
              </div>
            </li>
          );
        })}
      </ul>
      <div className="flex flex-wrap items-start justify-between gap-2 pt-1 border-t border-border">
        <WebhookSelfTest onDone={load} />
        <TestBatchesCleanup onDone={load} />
      </div>
    </Card>
  );
}
